import { render, staticRenderFns } from "./VuesticColorPickerInput.vue?vue&type=template&id=1b1d2486&"
import script from "./VuesticColorPickerInput.vue?vue&type=script&lang=js&"
export * from "./VuesticColorPickerInput.vue?vue&type=script&lang=js&"
import style0 from "./VuesticColorPickerInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticColorPickerInput.vue"
export default component.exports